import FingerprintJS from '@fingerprintjs/fingerprintjs';
import {isProd} from '@/utils/constants'
let fingerprint = null;         // 缓存最终的 visitorId
let initPromise = null;         // 缓存进行中的初始化 Promise
let server = null

function initFingerprint() {
	return (async () => {
		const fp = await FingerprintJS.load({ screen_resolution: true });
		const result = await fp.get();
		fingerprint = result.visitorId;
		return fingerprint;
	})();
}

const urlList = isProd === true ? [
	'https://fac-s1.lihmxssuqleitqcxpssa.uk:1818',
] : ['https://fac-test-server.czzhkractqqakfzdmrgd.cc:1818']

let tmpUrlList

let cachedPromise = null;

async function getServerUrl() {
	// 如果已经有缓存的 Promise，直接返回
	if (cachedPromise) {
		return cachedPromise;
	}

	// 如果已经有确定的 server，直接返回
	if (server) {
		return server;
	}

	cachedPromise = (async () => {
		let requests;
		try {
			// 为每个 URL 创建一个请求 Promise，带超时控制
			requests = urlList.map(url => {
				return (async () => {
					try {
						// 创建超时 Promise
						const timeoutPromise = new Promise((_, reject) => {
							setTimeout(() => reject(new Error('Request timeout')), 20000);
						});

						// 创建请求 Promise
						const requestPromise = getRequestAsync('test/connection', url);

						// 使用 Promise.race 实现超时控制
						const result = await Promise.race([requestPromise, timeoutPromise]);

						if (result?.ok === true) {
							await result.text();
							return url; // 返回成功的 URL
						} else {
							throw new Error('Response not ok');
						}
					} catch (e) {
						// 如果请求失败，抛出错误
						throw e;
					}
				})();
			});

			// 使用 Promise.race 获取最快成功的请求
			server = await Promise.race(requests);
			return server;
		} catch (e) {
			// 如果所有请求都失败，使用 Promise.allSettled 检查详情
			const results = await Promise.allSettled(requests);
			const successfulResult = results.find(r => r.status === 'fulfilled');

			if (successfulResult) {
				server = successfulResult.value;
				return server;
			}

			// 所有请求都失败
			// throw new Error('All servers failed to respond');
		} finally {
			// 清空缓存的 Promise，以便下次可以重试
			cachedPromise = null;
		}
	})();

	return cachedPromise;
}

const bootstrap = (async () => {
	try {
		await getServerUrl();
		initPromise = initFingerprint();
	} catch (e) {
	}
})();

async function getServerUrlInternal(index) {
	try {
		const url = tmpUrlList[index];

		// 创建超时Promise
		const timeoutPromise = new Promise((_, reject) => {
			setTimeout(() => reject(new Error('Request timeout')), 5000);
		});

		// 创建请求Promise
		const requestPromise = getRequestAsync('test/connection', url);

		// 使用Promise.race来实现超时控制
		const result = await Promise.race([requestPromise, timeoutPromise]);

		if (result?.ok === true) {

			await result.text();
			server = url;
			return url;
		} else if (index < tmpUrlList.length - 1) {
			const newIndex = index + 1;
			return await getServerUrlInternal(newIndex);
		}
	} catch (e) {
		// 超时或其他错误，尝试下一个服务器
		if (index < tmpUrlList.length - 1) {
			const newIndex = index + 1;
			return await getServerUrlInternal(newIndex);
		}
	}
}


function shuffleArray(array) {
	for (let i = array.length - 1; i > 0; i--) {
		const j = Math.floor(Math.random() * (i + 1));
		[array[i], array[j]] = [array[j], array[i]];
	}
	return array;
}

async function getFingerprint() {
	if (fingerprint) return fingerprint;
	if (initPromise) return initPromise;
	// 理论上不会走到这里；兜底再触发一次
	initPromise = (async () => {
		const fp = await FingerprintJS.load({screen_resolution: true});
		const result = await fp.get();
		fingerprint = result.visitorId;
		return fingerprint;
	})();
	return initPromise;
}

async function getRequestAsync(url, baseUrl) {
	const customHeaders = new Headers();
	// myHeaders.append("User-Agent", "Apifox/1.0.0 (https://www.apifox.cn)");
	customHeaders.append("Content-Type", "application/json");
	customHeaders.append("Accept", "*/*");
	// myHeaders.append("Host", "124.220.215.2");
	customHeaders.append("Connection", "keep-alive");
	const sessionId = localStorage.getItem('sessionId')
	if (sessionId) {
		customHeaders.append("sessionId", sessionId);
	}


	const fp = await getFingerprint()
	if (fp) {
		customHeaders.append("fp", fp);
	}

	// Add cache-control headers to prevent caching
	customHeaders.append("Cache-Control", "no-cache");
	customHeaders.append("Pragma", "no-cache");
	customHeaders.append("Expires", "0");

	const requestOptions = {
		method: 'GET',
		headers: customHeaders,
		redirect: 'follow'
	};
	// const self = this
	if (baseUrl) {
		const response = await fetch(`${baseUrl}/${url}`, requestOptions)
		return response
	} else {
		const remoteServer = await getServerUrl()
		const response = await fetch(`${remoteServer}/${url}`, requestOptions)
		return response.json()
	}

}

async function postRequestAsync(url, data) {

	const customHeaders = new Headers()
	customHeaders.append('Content-Type', 'application/json')
	customHeaders.append('Accept', '*/*')
	customHeaders.append('Connection', 'keep-alive')
	const sessionId = localStorage.getItem('sessionId')
	if (sessionId) {
		customHeaders.append('sessionId', sessionId)
	}


	const fp = await getFingerprint()
	if (fp) {
		customHeaders.append("fp", fp);
	}

	// Add cache-control headers to prevent caching
	customHeaders.append('Cache-Control', 'no-cache')
	customHeaders.append('Pragma', 'no-cache')
	customHeaders.append('Expires', '0')

	const raw = JSON.stringify(data);

	const requestOptions = {
		method: 'POST',
		headers: customHeaders,
		body: raw,
		redirect: 'follow'
	};

	// const self = this
	const remoteServer = await getServerUrl()
	const response = await fetch(`${remoteServer}/${url}`, requestOptions)
	return response.json()
}

export {
	getRequestAsync,
	postRequestAsync,
	getFingerprint,
	getServerUrl
}
